import { FaTrophy, FaClock, FaUsers, FaCode, FaStar, FaCreditCard } from "react-icons/fa";
import { Link } from "react-router-dom";
import Button from "../../ReusableComponent/Button";

const TournamentCard = ({
  title,
  badges = [],
  prizePool,
  description,
  startsIn,
  participants,
  problems,
  rating,
  rules,
  categories = [],
  registerLink,
}) => {
  return (
    // <div className="col-md-8 mb-4">
      <div className="rounded border shadow-sm bg-dark text-light p-5">
        
        {/* Header */}
        <div className="d-flex justify-content-between align-items-start mb-4">
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-center bg-primary rounded-circle me-3" style={{ width: 60, height: 60 }}>
              <FaTrophy size={28} className="text-white" />
            </div>
            <div>
              <h3 className="fw-bold mb-1">{title}</h3>
              <div className="d-flex align-items-center gap-2">
                {badges.map((badge, i) => (
                  <span key={i} className={`badge bg-${badge.color}`}>{badge.label}</span>
                ))}
              </div>
            </div>
          </div>
          <div className="text-end">
            <h4 className="text-warning fw-bold mb-1">{prizePool}</h4>
            <small className="text-muted">Prize Pool</small>
          </div>
        </div>

        {/* Description */}
        <p className="text-muted mb-4">{description}</p>

        {/* Stats */}
        <div className="row mb-5">
          <div className="col-md-3">
            <div className="text-center p-3 bg-secondary rounded hover-card">
              <FaClock size={24} className="text-primary mb-2" />
              <h6 className="mb-1">{startsIn}</h6>
              <small className="text-white">Starts In</small>
            </div>
          </div>
          <div className="col-md-3">
            <div className="text-center p-3 bg-secondary rounded hover-card">
              <FaUsers size={24} className="text-info mb-2" />
              <h6 className="mb-1">{participants}</h6>
              <small className="text-white">Participants</small>
            </div>
          </div>
          <div className="col-md-3">
            <div className="text-center p-3 bg-secondary rounded hover-card">
              <FaCode size={24} className="text-success mb-2" />
              <h6 className="mb-1">{problems}</h6>
              <small className="text-white">Problems</small>
            </div>
          </div>
          <div className="col-md-3">
            <div className="text-center p-3 bg-secondary rounded hover-card">
              <FaStar size={24} className="text-warning mb-2" />
              <h6 className="mb-1">{rating}</h6>
              <small className="text-white">Rating</small>
            </div>
          </div>
        </div>

        {/* Rules */}
        <div className="mb-4">
          <h5 className="fw-bold mb-3">Contest Rules</h5>
          <div className="bg-secondary p-3 rounded">{rules}</div>
        </div>

        {/* Categories */}
        <div className="mb-5">
          <h5 className="fw-bold mb-3">Problem Categories</h5>
          <div className="d-flex flex-wrap gap-2">
            {categories.map((cat, i) => (
              <span key={i} className="badge bg-dark border">{cat}</span>
            ))}
          </div>
        </div>

        {/* Register Button */}
         <Link to={`/tournaments-register/${title}`}>
          <Button variant="gradient" fullWidth>
            <FaCreditCard /> Register for Tournament
          </Button>
        </Link>
      </div>
    // </div>
  );
};

export default TournamentCard;